import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader, ComponentFooter, DeprecatedComponentAlert } from 'components/thumbprint-components';
import { InlineCode } from 'components/mdx';
import Alert from 'components/alert';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/avatar/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
        # Get package information by NPM package name.
        packageTable: thumbprintComponent(name: { eq: "@thumbtack/thumbprint-scss" }) {
            ...PackageTableFragment
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <Alert type="warning" title="Avatar component is out-of-date" mdxType="Alert">
    The sizes and styles available in the SCSS version of the <InlineCode mdxType="InlineCode">Avatar</InlineCode>{' '}
    component{' '}
    <a href="https://github.com/thumbtack/thumbprint/issues/25" title="Details about the recent changes">
        are out-of-date
    </a>
    . <a href="/components/avatar/react/">Use the React component</a> if possible or <a href="/help/">
        reach out to the Design Systems team
    </a> if you are blocked.
    </Alert>
    <h2>{`Avatar Sizes`}</h2>
    <h3>{`Extra Large`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-avatar tp-avatar--xlarge">
    <img src="https://i.pravatar.cc/140" class="tp-avatar__img" />
</div>
`}</code></pre>
    <h3>{`Large`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-avatar tp-avatar--large">
    <img src="https://i.pravatar.cc/140" class="tp-avatar__img" />
</div>
`}</code></pre>
    <h3>{`Medium`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-avatar tp-avatar--medium">
    <img src="https://i.pravatar.cc/140" class="tp-avatar__img" />
</div>
`}</code></pre>
    <h3>{`Small`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-avatar tp-avatar--small">
    <img src="https://i.pravatar.cc/140" class="tp-avatar__img" />
</div>
`}</code></pre>
    <h3>{`Extra Small`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-avatar tp-avatar--xsmall">
    <img src="https://i.pravatar.cc/140" class="tp-avatar__img" />
</div>
`}</code></pre>
    <h2>{`Avatar Badges`}</h2>
    <DeprecatedComponentAlert mdxType="DeprecatedComponentAlert">
    Avatar badges are deprecated. Status indicators such as "online" status, hired checkmarks, and
    notification alerts should be implemented as separate elements placed next to the avatar.
    </DeprecatedComponentAlert>
    <h3>{`Hired`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-avatar tp-avatar--xlarge">
    <img src="https://i.pravatar.cc/140" class="tp-avatar__img" />
    <div class="tp-avatar__badge tp-avatar__badge--hired" />
</div>
`}</code></pre>
    <h3>{`Notification`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-avatar tp-avatar--xlarge">
    <img src="https://i.pravatar.cc/140" class="tp-avatar__img" />
    <div class="tp-avatar__badge tp-avatar__badge--notification">99</div>
</div>
`}</code></pre>
    <ComponentFooter data={props.data} mdxType="ComponentFooter" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      